function RegistrationWizard(data) {
    var self = this;

    self.isBusiness = ko.observable(false);

    self.businessOrIndividualStep = new BusinessOrIndividualStep(data.BusinessOrIndividualModel, self.isBusiness);
    self.businessOrIndividualStep.isDone.subscribe(function (isDone) {
        if (isDone) {
            self.disclosureStep.loadDisclosure(self.isBusiness());
            self.confirmIdentityStep.loadRegistrationFields(self.isBusiness());
            self.changeStep(self.disclosureStep);
        }
    });

    self.disclosureStep = new DisclosureStep();
    self.disclosureStep.isDone.subscribe(function (isDone) {
        if (isDone) {
            self.changeStep(self.confirmIdentityStep);
        }
    });

    self.confirmIdentityStep = new ConfirmIdentityStep();
    self.confirmIdentityStep.isDone.subscribe(function (isDone) {
        if (isDone) {
            self.changeStep(self.usernameStep);
        }
    });

    self.usernameStep = new UsernameStep(data);
    self.usernameStep.isDone.subscribe(function (isDone) {
        if (isDone) {
            window.location.href = '/Mobile/Registration/SendTemporaryPassword';
        }
    });

    self.currentStep = ko.observable(self.disclosureStep);
    self.changeStep = function (step) {
        var lastStep = self.currentStep();
        var mmenu = $('#mm_side_panels').data('mmenu');
        var animationDuration = mmenu.getInstance().conf.transitionDuration;
        var $stepElement = $('#' + step.id);

        self.currentStep(step);

        if (!$('#mm_side_panels').hasClass('mm-opened')) {
            mmenu.open();
        }
        $stepElement.show();
        mmenu.openPanel($stepElement);
        $stepElement.prop('tabindex', '-1');
        $stepElement.scrollTop(0);

        setTimeout(function() {
            if(lastStep && lastStep !== step) {
                $('#' + lastStep.id).hide();
            }
            $stepElement.focus();
        }, animationDuration);
    };

    self.next = function () {
        registrationArea.updateTitleBar(registrationArea.confirmIdentityNavBar);
        self.changeStep(self.confirmIdentityStep);
    };

    self.done = function() {
        self.confirmIdentityStep.done();
    };

    self.cancelRegistration = function () {
        if (self.currentStep().id === self.disclosureStep.id || self.currentStep().id === self.businessOrIndividualStep.id) {
            history.back();
        } else {
            $('#confirm_cancel_registration').show();
        }
    };

    self.isBusinessRegistrationEnabled = !!data.BBRegistrationEnabled;

    if (!self.isBusinessRegistrationEnabled) {
        self.disclosureStep.loadDisclosure(false);
        self.confirmIdentityStep.loadRegistrationFields(false);
        self.changeStep(self.disclosureStep);
    } else {
        self.changeStep(self.businessOrIndividualStep);
    }
}
